/**
 * Historical shim. Koko used to register the PokemonDPPt pixel font on
 * `document.fonts` here; the 2026-07-04 yap killed pixelation
 * end-to-end, so the widget now renders entirely in the studio's
 * system font stack (Inter / system-ui) and no webfont fetch is
 * needed.
 *
 * The export is kept because the (frozen) `KokoElement` still calls
 * `loadKokoFont(...)` during mount — it now resolves immediately
 * without touching the network. Delete the call site + this file
 * together in a future cleanup.
 */

export function loadKokoFont(_fontUrl: string): Promise<void> {
  return Promise.resolve();
}
